'use client'

import { type ComponentProps, Suspense } from 'react'

import dynamic from 'next/dynamic'

import type { LabScoreCard } from './lab-score-card'
import { LabScoreCardLoading } from './lab-score-card-loading'

const Card = dynamic(() => import('./lab-score-card').then((module) => module.LabScoreCard))

export const LabScoreCardLazy = (props: ComponentProps<typeof LabScoreCard>) => (
  <Suspense fallback={<LabScoreCardLoading title={props.product.label} attribution={props.attribution} />}>
    <Card {...props} />
  </Suspense>
)
